import { Box, Text } from '@mantine/core';
import classes from './SettingRow.module.css';

// One setting per row: label (with its ? help) on the left, the control capped on the right.
// `top` aligns the label with the first line of a tall control (a table or a textarea).
// `wide` lifts the cap for a table, which folds its own rows when the card is narrower.
const SettingRow = ({ label, htmlFor, help, top = false, wide = false, children }) => (
  <Box className={[classes.row, top && classes.top, wide && classes.wide].filter(Boolean).join(' ')}>
    <Box className={classes.label}>
      <Text component="label" htmlFor={htmlFor} size="sm">
        {label}
      </Text>
      {help}
    </Box>
    <Box miw={0}>{children}</Box>
  </Box>
);

export default SettingRow;
